import axios from 'axios'

const prefix = process.env.REACT_APP_backend_url+"/public";
export const getOptionList = async (productId)=>{
    return await axios.get(`${prefix}/product/${productId}/navigation`);
}

const v2Prefix = process.env.REACT_APP_public_url+"/public";
// export const getColorTargetList = async (productId, groupId) => {
//     console.log()
//     return await axios.get(`${v2Prefix}/partmanagement/group?productId=${productId}&assetType=COLOR&groupCode=${groupName}`);
// }

export const getColorWayDetail = async (productId, colorWayCode) => {
    return await axios.get(`${v2Prefix}/color/colorway?productId=${productId}&colorwayCode=${colorWayCode}`)
}


export const getGroupItemList = async (productId, stepType, groupId) => {
    const assetType = stepType === "PART_3D" ? "PART" : stepType;


    return await axios.get(`${v2Prefix}/partmanagement/group?productId=${productId}&assetType=${assetType}&partGroupId=${groupId}`);
}
